import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";
import { generalErrorMessage } from "@nju/utils";

export function DWInsufficientFundsError() {
  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {generalErrorMessage}
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="wallet-incircle-fail"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Brakuje Ci środków, by aktywować nju subskrypcja. Dodaj środki.
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Link
          href={portalRoutes.mojeKonto.platnosci.index.get()}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
          >
            dalej
          </A>
        </Link>
      </div>
    </Panel>
  );
}
